export default "__VITE_ASSET__BOy2ygw4__"